export default __webpack_public_path__ + "static/media/people.39b33c1a.png";